module.exports = __webpack_public_path__ + "static/img/learn.dce41fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/learn.png
// module id = JcnZ
// module chunks = 0